<template>
  <div class="comp-ly-field-filter">
    <div class="page-find-records-title" v-if="props.isQueryAll">
      <jw-space>
        <span>{{ $t('设置筛选条件') }}</span>
        <jw-tooltip :content="$t('筛选该操作执行时符合条件的记录')">
          <icon-question-circle :size="18" />
        </jw-tooltip>
      </jw-space>
      <jw-space>
        <span>{{ $t('符合以下') }}</span>
        <jw-select popup-container=".ly-field-find" v-model="filterQuery.queryAll" size="mini" :placeholder="$t('请选择')" :style="{ width: '80px' }" class="page-find-records-select" :options="data.selected" :trigger-props="{ updateAtScroll: true, position: 'bottom', autoFitPosition: false }"></jw-select>
        <span>{{ $t('筛选条件') }}</span>
      </jw-space>
    </div>
    <div class="page-find-records-content" ref="findRecordsContent">
      <jw-space direction="vertical" fill>
        <jw-form :model="data.form" ref="formRef" auto-label-width>
          <li class="rule-filter-item-sub" v-for="(sub, index) in filterQuery.conditions" :key="index">
            <jw-row :gutter="8">
              <jw-col :span="2"><div class="filter-left-tips">当</div> </jw-col>
              <jw-col :span="22">
                <jw-space direction="vertical" fill :size="4">
                  <jw-space :size="8">
                    <!-- 字段 -->
                    <span>#</span>
                    <jw-select :bordered="false" popup-container=".ly-field-find" class="rule-form-item-sub-select-field" v-model="sub.field" :placeholder="$t('请选择')" @change="changeChild($event, index)" allow-search :field-names="data.fieldNames" :trigger-props="{ updateAtScroll: true, position: 'bottom', autoFitPosition: false }">
                      <jw-option v-for="item in leadsFieldList" :key="item.value" :value="item.value" :title="item.label">{{ item.label }}</jw-option>
                    </jw-select>

                    <!-- 运算符 -->
                    <jw-select :bordered="false" popup-container=".ly-field-find" class="rule-form-item-sub-filter" v-model="sub.operation" :placeholder="$t('请选择')" @change="changeChildTwo($event, index)" allow-search :trigger-props="{ updateAtScroll: true, position: 'bottom', autoFitPosition: false }">
                      <jw-option v-for="item in getConditionFilterType(sub.field)" :key="item.value" :value="item?.value" :title="item?.label">{{ item?.label }}</jw-option>
                    </jw-select>
                  </jw-space>
                </jw-space>
              </jw-col>
            </jw-row>
            <template v-if="sub.operation != 'null' && sub.operation != 'not_null'">
              <jw-row :gutter="8" align="center">
                <jw-col :span="filterQuery.conditions.length > 1 ? 6 : 6">
                  <!-- 值or字段 -->
                  <jw-select popup-container=".ly-field-find" v-if="sub.operation != 'null' && sub.operation != 'not_null'" class="rule-form-item-sub-handle" v-model="sub.customType" :placeholder="$t('请选择')" allow-search :trigger-props="{ updateAtScroll: true, position: 'bottom', autoFitPosition: false }" @change="selectTypeChange($event, index)">
                    <jw-option v-for="item in filterSelectOptions(allObjList[sub.field]?.fieldType, allObjList[sub.field])" :key="item.value" :value="item?.value" :title="item?.label">{{ item?.label }}</jw-option>
                  </jw-select>
                </jw-col>
                <jw-col :span="filterQuery.conditions.length > 1 ? 16 : 18">
                  <template v-if="sub.customType == 1">
                    <!-- 选择字段 -->
                    <jw-dropdown
                      v-if="sub.operation != 'null' && sub.operation != 'not_null'"
                      popup-container=".ly-field-find"
                      @popup-visible-change="
                        () => {
                          data.searchGroup = '';
                          data.searchField = '';
                        }
                      "
                      placeholder="请选择"
                      :trigger-props="{ updateAtScroll: true }"
                    >
                      <jw-input-tag v-model="sub.mappingLabel" placeholder="请选择" :style="{ width: '100%', cursor: 'pointer' }" readonly :title="!sub.isDelete ? sub.mappingLabel : ''" class="find-field-mapping" />
                      <template #content>
                        <jw-space direction="vertical" fill style="width: 100%">
                          <template v-if="smStepList?.length">
                            <jw-input-search size="small" v-model="data.searchGroup" :style="{ width: '90%', margin: '8px 8px 0' }" :placeholder="$t('从以下步骤中选择')" allow-clear />
                            <!--  style="max-height: 200px; overflow: auto" -->
                            <div>
                              <template v-for="(group, groupIndex) in data.searchGroup ? smStepList?.filter((v) => v.label?.includes(data.searchGroup)) : smStepList" :key="groupIndex">
                                <jw-dsubmenu update-at-scroll>
                                  <template #default>
                                    <span :title="group.label">{{ group.label }}</span>
                                  </template>
                                  <template #content>
                                    <jw-space direction="vertical" fill>
                                      <div v-if="smFieldList(allObjList[sub.field], group.children, sub)?.length" class="group-show-fields">
                                        <jw-input-search v-model="data.searchField" size="small" :style="{ width: '90%', margin: '8px' }" :placeholder="$t('搜索字段名称')" allow-clear />
                                        <!--  style="max-height: 200px; max-width: 280px; overflow: auto" -->
                                        <div class="group-show-fields-list">
                                          <template v-for="(field, fieldIndex) in data.searchField ? smFieldList(allObjList[sub.field], group.children, sub)?.filter((v) => v.fieldName?.includes(data.searchField)) : smFieldList(allObjList[sub.field], group.children, sub)" :key="fieldIndex">
                                            <jw-doption @click="selectField(group, index, field)" :title="field.fieldName">{{ field.fieldName }}-【{{ outFieldTypeObj[field.fieldType] }}】</jw-doption>
                                          </template>
                                        </div>
                                      </div>
                                      <div style="padding: 4px 8px" v-else>暂无可选字段</div>
                                    </jw-space>
                                  </template>
                                </jw-dsubmenu>
                              </template>
                            </div>
                          </template>
                          <div style="padding: 4px 8px" v-else>暂无可选步骤</div>
                        </jw-space>
                      </template>
                    </jw-dropdown>
                  </template>

                  <template v-else-if="sub.customType == 4">
                    <!-- 选择记录 -->
                    <jw-dropdown
                      v-if="sub.operation != 'null' && sub.operation != 'not_null'"
                      popup-container=".ly-field-find"
                      @popup-visible-change="
                        () => {
                          data.searchGroup = '';
                          data.searchField = '';
                        }
                      "
                      placeholder="请选择"
                      :trigger-props="{ updateAtScroll: true }"
                    >
                      <jw-input-tag v-model="sub.mappingLabel" placeholder="请选择" :style="{ width: '100%', cursor: 'pointer' }" readonly :title="!sub.isDelete ? sub.mappingLabel : ''" class="find-field-mapping" />
                      <template #content>
                        <jw-space direction="vertical" fill style="width: 100%">
                          <template v-if="smStepList?.length">
                            <jw-input-search size="small" v-model="data.searchGroup" :style="{ width: '90%', margin: '8px 8px 0' }" :placeholder="$t('从以下步骤中选择')" allow-clear />
                            <div>
                              <template v-for="(group, groupIndex) in data.searchGroup ? smStepList?.filter((v) => v.label?.includes(data.searchGroup))?.filter((e) => e?.value?.split(':')?.[2] == sub?.fieldExt) : smStepList?.filter((e) => e?.value?.split(':')?.[2] == sub?.fieldExt)" :key="groupIndex">
                                <jw-doption popup-container=".ly-field-find" position="tr" @click="selectField(group, index)">
                                  <template #default>
                                    <span :title="group.label">{{ group.label }}</span>
                                  </template>
                                </jw-doption>
                              </template>
                            </div>
                          </template>
                          <div style="padding: 4px 8px" v-else>暂无可选步骤</div>
                        </jw-space>
                      </template>
                    </jw-dropdown>
                  </template>
                  <!-- 动态记录特殊处理 -->
                  <template v-else-if="sub.customType == 6">
                    <!-- 选择记录 -->
                    <jw-dropdown
                      v-if="sub.operation != 'null' && sub.operation != 'not_null'"
                      popup-container=".ly-field-find"
                      @popup-visible-change="
                        () => {
                          data.searchGroup = '';
                          data.searchField = '';
                        }
                      "
                      placeholder="请选择"
                      :trigger-props="{ updateAtScroll: true }"
                    >
                      <jw-input-tag v-model="sub.mappingLabel" placeholder="请选择" :style="{ width: '100%', cursor: 'pointer' }" readonly :title="!sub.isDelete ? sub.mappingLabel : ''" class="find-field-mapping" />
                      <template #content>
                        <jw-space direction="vertical" fill style="width: 100%">
                          <template v-if="smStepList?.filter((v) => v.triggerType != 5)?.length">
                            <jw-input-search size="small" v-model="data.searchGroup" :style="{ width: '90%', margin: '8px 8px 0' }" :placeholder="$t('从以下步骤中选择')" allow-clear />
                            <div>
                              <template v-for="(group, groupIndex) in data.searchGroup ? smStepList?.filter((v) => v.triggerType != 5 && v.label?.includes(data.searchGroup)) : smStepList?.filter((v) => v.triggerType != 5)" :key="groupIndex">
                                <jw-doption popup-container=".ly-field-find" position="left" @click="selectField(group, index, null, '对象')">
                                  <template #default>
                                    <span :title="group.label">{{ group.label?.replace('记录', '对象') }}</span>
                                  </template>
                                </jw-doption>
                              </template>
                            </div>
                          </template>
                          <div style="padding: 4px 8px" v-else>暂无可选步骤</div>
                        </jw-space>
                      </template>
                    </jw-dropdown>
                  </template>

                  <template v-else>
                    <template v-if="sub.operation != 'null' && sub.operation != 'not_null'">
                      <!-- 2,3,4,5 -->
                      <template v-if="[2, 3, 4, 5].includes(allObjList[sub.field]?.fieldType || allObjList[sub.field]?.business?.fieldType)">
                        <fh-select v-if="!(sub.operation == 'null' || sub.operation == 'not_null')" :placeholder="$t('请选择')" :multiple="checkMultiple(sub)" class="rule-form-item-sub-select filter-select" v-model.trim="sub.value" :options="getOptions(sub.field)">
                          <template #label="{ data }">
                            <ly-show-filters :showInner="data.label" showType="filters" />
                          </template>
                        </fh-select>

                        <div style="width: 0" v-else-if="sub.operation == 'null' || sub.operation == 'not_null'"></div>
                      </template>
                      <!-- 6 人员选择是一个单框与角色权限中的添加人员一样 -->
                      <template v-else-if="allObjList[sub.field]?.fieldType == 6 || allObjList[sub.field]?.business?.fieldType == 6">
                        <template v-if="(sub.operation != 'null' && sub.operation != 'not_null') || sub.operation == ''">
                          <fh-person position="bl" :maxTagCount="2" :item="sub" :multiple="sub.operation === 'equals' || sub.operation === 'not_equals' ? false : true" @cb="getValUser($event, index, 1)"> </fh-person>

                          <!-- <xl-tree-member-modal :tree="userTree" @cb="getValUser($event, index, 1)" :multipleDep="sub.operation == 'equals' || sub.operation == 'not_equals' ? false : true" :user="sub?.userList">
                            <jw-input-tag v-model="sub.mappingLabel" :max-tag-count="2" class="rule-form-item-sub-select" readonly :placeholder="$t('请选择')" />
                          </xl-tree-member-modal> -->
                        </template>

                        <div style="width: 0" v-else></div>
                      </template>
                      <!-- 7数字 此处会根据接口fieldExt返回的数据：例如：0,1,2,3,(100)%等等判断数字的精度 -->
                      <template v-else-if="(allObjList[sub.field]?.fieldType === 7 && sub.operation != 'null' && sub.operation != 'not_null') || (allObjList[sub.field]?.business?.fieldType == 7 && sub.operation != 'null' && sub.operation != 'not_null')">
                        <div style="width: 0" v-if="sub.operation == 'null' || sub.operation == 'not_null'"></div>
                        <jw-input-number v-else class="rule-form-item-sub-select" v-model="sub.value" :placeholder="$t('请选择')" @input="(event) => getPrecisionNum(event, allObjList[sub.field])" :formatter="(event) => isShowThousandFormatter(event, allObjList[sub.field])" :parser="(value) => value.replace(/,/g, '')" :precision="getPrecision(allObjList[sub.field], precisionNum)" />
                      </template>
                      <!-- 日期格式 -->
                      <template v-else-if="allObjList[sub.field]?.fieldType == 8 || allObjList[sub.field]?.business?.fieldType == 8">
                        <div class="rule-form-item-sub-select">
                          <xl-date-variable :objList="allObjList[sub.field]" :record="sub" @cb="getDateVariable($event, index)"></xl-date-variable>
                        </div>
                      </template>
                      <!-- 9日期范围 -->
                      <template v-else-if="(allObjList[sub.field]?.fieldType === 9 && sub.operation != 'null' && sub.operation != 'not_null') || (allObjList[sub.field]?.business?.fieldType == 9 && sub.operation != 'null' && sub.operation != 'not_null')">
                        <jw-range-picker v-if="allObjList[sub.field]?.fieldExt == '0' || allObjList[sub.field]?.business?.fieldExt == '0'" v-model="sub.value" class="rule-form-item-sub-select" :trigger-props="{ updateAtScroll: true }" />
                        <jw-range-picker v-else-if="allObjList[sub.field]?.fieldExt == '1' || allObjList[sub.field]?.business?.fieldExt == '1'" class="rule-form-item-sub-select" v-model="sub.value" :disabledDate="(current) => dayjs(current).isAfter(dayjs())" :trigger-props="{ updateAtScroll: true }" />
                        <jw-range-picker v-else v-model="sub.value" class="rule-form-item-sub-select" :disabledDate="(current) => dayjs(current).isBefore(dayjs(new Date().getTime() - 24 * 60 * 60 * 1000))" :trigger-props="{ updateAtScroll: true }" />
                      </template>
                      <!-- 10 级联选择器 :path-mode="true"-->
                      <template v-else-if="allObjList[sub.field]?.fieldType == 10 || allObjList[sub.field]?.business?.fieldType == 10">
                        <jw-cascader :max-tag-count="1" :path-mode="true" v-if="sub.operation == 'equals' || sub.operation == 'not_equals' || sub.operation == ''" class="rule-form-item-sub-select" :options="JSON.parse(allObjList[sub.field]?.fieldType != 21 ? allObjList[sub.field]?.fieldExt : allObjList[sub.field]?.business?.fieldExt)" allow-search v-model="sub.value" :placeholder="$t('请选择')">
                          <template #label="{ data }">
                            <ly-show-filters showType="filters" :showInner="data.label" />
                          </template>
                        </jw-cascader>
                        <jw-cascader :max-tag-count="1" :path-mode="true" v-else-if="sub.operation == 'in' || sub.operation == 'not_in'" class="rule-form-item-sub-select" :options="JSON.parse(allObjList[sub.field]?.fieldType != 21 ? allObjList[sub.field]?.fieldExt : allObjList[sub.field]?.business?.fieldExt)" allow-search v-model="sub.value" :placeholder="$t('请选择')" multiple>
                          <template #label="{ data }">
                            <ly-show-filters showType="filters" :showInner="data.label" />
                          </template>
                        </jw-cascader>
                        <div style="width: 0" v-else-if="sub.operation == 'null' || sub.operation == 'not_null'"></div>
                      </template>
                      <!-- 16 金额 -->
                      <template v-else-if="allObjList[sub.field]?.fieldType === 16 || allObjList[sub.field]?.business?.fieldType == 16">
                        <jw-input-number v-if="(sub.operation != 'null' && sub.operation != 'not_null') || sub.operation == ''" class="rule-form-item-sub-select" v-model="sub.value" :placeholder="$t('请选择')" @input="(event) => getPrecisionNum(event, allObjList[sub.field])" :formatter="(event) => isShowThousandFormatter(event, allObjList[sub.field])" :parser="(value) => value.replace(/,/g, '')" :precision="getPrecision(allObjList[sub.field], precisionNum)" />
                        <div v-else style="width: 0"></div>
                      </template>
                      <!-- 22 部门 -->
                      <template v-else-if="allObjList[sub.field]?.fieldType == 22 || allObjList[sub.field]?.business?.fieldType == 22">
                        <xl-tree-member-modal :tree="departTree" v-if="(sub.operation != 'null' && sub.operation != 'not_null') || sub.operation == ''" @cb="getValUser($event, index, 2)" :multipleDep="sub.operation == 'equals' || sub.operation == 'not_equals' ? false : true" :depart="sub.departList">
                          <jw-input-tag v-model="sub.mappingLabel" :max-tag-count="2" class="rule-form-item-sub-select" readonly :placeholder="$t('请选择')" />
                        </xl-tree-member-modal>
                        <div style="width: 0" v-else></div>
                      </template>
                      <!-- 23百分比 查找关联-->
                      <template v-else-if="allObjList[sub.field]?.fieldType == 23 || allObjList[sub.field]?.business?.fieldType == 23">
                        <jw-input-number v-if="(sub.operation != 'null' && sub.operation != 'not_null') || sub.operation == ''" class="rule-form-item-item-select percentage" v-model="sub.value" :placeholder="$t('请输入')" @input="(event) => getPrecisionNum(event, allObjList[sub.field])" :precision="getPrecision(allObjList[sub.field], precisionNum)"> <template #append> % </template> </jw-input-number>
                        <div style="width: 0" v-else></div>
                      </template>
                      <!-- 24计算字段 -->
                      <template v-else-if="allObjList[sub.field]?.fieldType == 24 || allObjList[sub.field]?.business?.fieldType == 24">
                        <template v-if="(sub.operation != 'null' && sub.operation != 'not_null') || sub.operation == ''">
                          <!-- 计算字段的fieldExt的type=5 :数字（汇总累计）type=7 :数字-->
                          <jw-input-number v-if="(tools.isJSON(allObjList[sub.field]?.fieldExt) && [5, 7].includes(JSON.parse(allObjList[sub.field]?.fieldExt)?.type)) || (tools.isJSON(allObjList[sub.field]?.business?.fieldExt) && [5, 7].includes(JSON.parse(allObjList[sub.field]?.business?.fieldExt)?.type))" class="rule-form-item-sub-select" v-model="sub.value" @input="(event) => getPrecisionNum(event, allObjList[sub.field])" :formatter="(event) => isShowThousandFormatter(event, allObjList[sub.field])" :parser="(value) => value.replace(/,/g, '')" :precision="getPrecision(allObjList[sub.field], precisionNum, true)" :placeholder="$t('请选择')" />
                          <!-- 计算字段的fieldExt的type=6 :金额(汇总金额) type=16 :金额 -->
                          <jw-input-number v-else-if="(tools.isJSON(allObjList[sub.field]?.fieldExt) && [6, 16].includes(JSON.parse(allObjList[sub.field]?.fieldExt)?.type)) || (tools.isJSON(allObjList[sub.field]?.business?.fieldExt) && [6, 16].includes(JSON.parse(allObjList[sub.field]?.business?.fieldExt)?.type))" class="rule-form-item-sub-select" v-model="sub.value" @input="(event) => getPrecisionNum(event, allObjList[sub.field])" :formatter="(event) => isShowThousandFormatter(event, allObjList[sub.field])" :parser="(value) => value.replace(/,/g, '')" :precision="getPrecision(allObjList[sub.field], precisionNum, true)" :placeholder="$t('请选择')" />
                          <!-- 计算字段的fieldExt的type=0 :文本 -->
                          <jw-input v-else-if="(tools.isJSON(allObjList[sub.field]?.fieldExt) && [0].includes(JSON.parse(allObjList[sub.field]?.fieldExt)?.type)) || (tools.isJSON(allObjList[sub.field]?.business?.fieldExt) && [0].includes(JSON.parse(allObjList[sub.field]?.business?.fieldExt)?.type))" v-model.trim="sub.value" :placeholder="$t('请输入')" class="rule-form-item-sub-select" />
                          <!-- 计算字段的fieldExt的type=23 :百分比 -->
                          <jw-input-number v-else-if="(tools.isJSON(allObjList[sub.field]?.fieldExt) && [23].includes(JSON.parse(allObjList[sub.field]?.fieldExt)?.type)) || (tools.isJSON(allObjList[sub.field]?.business?.fieldExt) && [23].includes(JSON.parse(allObjList[sub.field]?.business?.fieldExt)?.type))" class="rule-form-item-sub-select percentage" v-model="sub.value" :placeholder="$t('请选择')" @input="(event) => getPrecisionNum(event, allObjList[sub.field])" :precision="getPrecision(allObjList[sub.field], precisionNum, true)">
                            <template #append> % </template>
                          </jw-input-number>
                          <!-- 计算字段的fieldExt的type=8 :日期 -->
                          <template v-else-if="(tools.isJSON(allObjList[sub.field]?.fieldExt) && [8].includes(JSON.parse(allObjList[sub.field]?.fieldExt)?.type)) || (tools.isJSON(allObjList[sub.field]?.business?.fieldExt) && [8].includes(JSON.parse(allObjList[sub.field]?.business?.fieldExt)?.type))">
                            <xl-date-variable :objList="data?.objList[sub.field]" :record="sub" @cb="getDateVariable($event, index)"></xl-date-variable>
                          </template>
                        </template>
                        <div v-else style="width: 0"></div>
                      </template>
                      <!-- 单行文本 obj[sub.field] -->
                      <template v-else>
                        <jw-input v-if="(sub.operation != 'null' && sub.operation != 'not_null') || sub.operation == ''" v-model.trim="sub.value" :placeholder="$t('请输入')" class="rule-form-item-sub-select" />
                        <div v-else style="width: 0"></div>
                      </template>
                    </template>
                  </template>
                </jw-col>
                <jw-col :span="filterQuery.conditions.length > 1 ? 2 : 0">
                  <icon-minus-circle class="del-item" :size="20" v-if="filterQuery.conditions.length > 1" @click="deleteItem(index)" />
                </jw-col>
              </jw-row>
            </template>
          </li>
        </jw-form>
        <jw-button type="outline" size="mini" @click="addCondition">
          <template #icon> <icon-plus /> </template>
          {{ $t('添加条件') }}
        </jw-button>
      </jw-space>
    </div>
  </div>
</template>

<script setup>
import { reactive, ref, inject, computed, nextTick, watch } from 'vue';
import { outFieldTypeObj } from '@/utils/const';
import { tools } from '@/utils/tools';
import { useI18n } from 'vue-i18n';
// 精度
import useThousandOption from '@/hooks/thousand';
import dayjs from 'dayjs';
import FhSelect from '@/components/fh-select/fh-select.vue';

// 处理精度 千分符
const { precisionNum, isShowThousandFormatter, getPrecisionNum, getPrecision } = useThousandOption();
const { t } = useI18n();
const emits = defineEmits(['cb']);

console.log('1-开始创建组件-setup');
const props = defineProps({
  targetObj: {
    type: Array,
    default: () => []
  },
  //步骤索引
  stepIndex: {
    type: Number,
    default: 1
  },
  record: {
    type: Array,
    default: () => []
  },
  isQueryAll: {
    type: Boolean,
    default: false
  }
});
const data = reactive({
  searchGroup: '',
  searchField: '',
  triggerInfo: inject('flowStepParams')?.triggerInfo || [],
  filterType: inject('engineGlobal')?.filterType || {}, //默认值添加
  sourceMappingFieldList: inject('flowStepParams')?.sourceMappingFieldList || [],
  selected: [
    { label: t('所有'), value: true },
    { label: t('任一'), value: false }
  ]
});
const leadsFieldList = computed(() => props.targetObj?.filter((tItem) => ![25, 27].includes(tItem.fieldType))?.filter((v) => v.value != 'businessId')); // 左侧数据源
const allObjList = computed(() => {
  return leadsFieldList.value.reduce((pre, cur) => {
    pre[cur.value] = cur;
    return pre;
  }, {});
});

//下拉字段判断多选
const checkMultiple = (sub) => {
  if (sub.operation == 'equals' || sub.operation == 'not_equals' || sub.operation == '') {
    return false;
  }
  return true;
};

//获取下拉列表
const getOptions = (field) => {
  const extInfo = allObjList.value[field]?.fieldType != 21 ? allObjList.value[field]?.fieldExt : allObjList.value[field]?.business?.fieldExt;
  return tools.isJSON(extInfo) ? JSON.parse(extInfo) : extInfo;
};

// 添加默认值
const addDefaultValue = () => {
  const _fieldInfo = leadsFieldList.value?.[0];
  const _field = _fieldInfo?.value;
  const _operation = _fieldInfo ? getConditionFilterType(_field)[0].value : '';
  const _fieldType = _fieldInfo ? _fieldInfo.fieldType : null;
  const defaultValue = { operation: _operation, isGroup: false, parentId: undefined, field: _field, value: null, fieldType: _fieldType, customType: null, mappingLabel: [] };
  return defaultValue;
};
// 条件类型
const filterSelectOptions = (targetFieldType, targetField) => {
  if (targetField?.value == 'entityType') {
    return [
      {
        label: '对象',
        value: 6
      },
      {
        label: '自定义',
        value: 2
      }
    ];
  }
  if ([18, 26].includes(targetFieldType)) {
    return handleOptions.value.filter((v) => v.value !== 2 && v.value !== 4);
  } else if ([12, 25].includes(targetFieldType)) {
    return handleOptions.value.filter((v) => v.value !== 2);
  } else {
    return handleOptions.value.filter((v) => v.value !== 4);
  }
};

const copyRecord = computed(() => props.record);
// console.log('初始化调整11', JSON.parse(JSON.stringify(copyRecord.value)));

const filterList = computed(() => {
  if (copyRecord.value?.conditions.length === 1 && copyRecord.value?.conditions[0].field === '') {
    const dftValue = addDefaultValue();
    console.log('默认值', dftValue);
    return [dftValue];
  } else {
    return copyRecord.value?.conditions?.map((v) => {
      // 初始化返回对象
      const result = {
        ...v,
        fieldExt: undefined,
        value: null,
        mappingLabel: [],
        business: null
      };

      // 设置 fieldExt
      const targetObjItem = props.targetObj.find((k) => v.field === k.value);
      if (targetObjItem) {
        result.fieldExt = targetObjItem.fieldExt;
      }

      // 设置 value
      if ([1, 4, 6].includes(v.customType)) {
        result.value = v.value; // 如果 customType 为 1 或 4，使用 v.value
        result.mappingLabel = v.mappingLabel || [];
      } else if (v.customType === 2) {
        if (v.fieldType == 16) {
          result.value = tools.getPrice(v.value, result?.fieldExt || 2); // fieldType 为 16，调用 getPrice
        } else if (v.fieldType == 24 && tools.isJSON(result?.fieldExt) && (JSON.parse(result?.fieldExt)?.type == 6 || JSON.parse(result?.fieldExt)?.type == 16)) {
          result.value = tools.getPrice(v.value, result?.fieldExt || 2); // fieldType 为 16，调用 getPrice
        } else if ([6, 22].includes(Number(v.fieldType))) {
          console.log('人员处理11', JSON.parse(JSON.stringify(v)));
          const handleValue = v.business ? v.business : v.value;
          const dept = handleValue?.departIds?.map((v) => v.name) || [];
          const user = handleValue?.userIds?.map((v) => v.name) || [];
          const userIds = handleValue?.userIds?.map((v) => v.id);
          const departIds = handleValue?.departIds?.map((v) => v.id);
          result.userDept = [...dept, ...user];
          result.mappingLabel = result.userDept || [];
          result.business = v.business ? v.business : v.value;
          result.userList = handleValue?.userIds?.map((v) => {
            return {
              ...v,
              userName: v.name,
              avatarOrigin: v.avatar
            };
          });
          result.departList = handleValue?.departIds?.map((v) => {
            return {
              ...v,
              departmentName: v.name,
              avatarOrigin: v.avatar
            };
          });
          // result.value = v.value;
          result.value = JSON.stringify({
            userIds: userIds,
            departIds: departIds
          });
        } else if ([2, 3, 4, 5, 10].includes(Number(v.fieldType))) {
          console.log('consoleLog2');

          if (['in', 'not_in'].includes(v.operation)) {
            if (v.fieldType == 10) {
              result.value = v.value?.split(',')?.map((str) => str?.split('/'));
            } else {
              // 兼容老数据
              console.log('兼容老数据333', v.value);
              result.value = Array.isArray(v.value) ? v.value : v.value?.split(',');
              console.log('兼容老数据333', v.value);
            }
          } else if (v.fieldType == 10 && ['equals', 'not_equals'].includes(v.operation)) {
            result.value = Array.isArray(v.value) ? v.value : v.value?.split('/');
          } else {
            result.value = v.value;
          }
        } else if (v.fieldType == 23 || (v.fieldType == 24 && tools.isJSON(result?.fieldExt) && JSON.parse(result?.fieldExt)?.type == 23)) {
          result.value = tools.getPercentage(v.value, tools.isJSON(v.targetExt) && JSON.parse(v.targetExt)?.numberFormat); // fieldType 为 23，调用 getPercentage
          result.mappingLabel = v.mappingLabel || [];
        } else {
          console.log('consoleLog4');
          result.value = v.value; // 其他情况，直接使用 v.value
          result.mappingLabel = v.mappingLabel || [];
        }
      }
      return result;
    });
  }
});
console.log('初始化调整22', JSON.parse(JSON.stringify(filterList.value)));

const filterQuery = ref({
  ...copyRecord.value,
  conditions: filterList.value
});

const stepIndex = computed(() => props.stepIndex + 2);
const findRecordsContent = ref(null);
const departTree = ref({
  checkDepartment: true,
  isAll: false,
  data: [], // 数组 必传
  checkUser: false
});
const handleOptions = ref([
  {
    label: '字段',
    value: 1
  },
  {
    label: '自定义',
    value: 2
  },
  {
    label: '记录',
    value: 4
  }
]);

const changeChild = (e, index) => {
  filterQuery.value.conditions[index].operation = '';
  filterQuery.value.conditions[index].value = null;
  // 这里动态记录逻辑特殊处理
  if (e == 'entityType') {
    filterQuery.value.conditions[index].customType = 6;
  } else {
    filterQuery.value.conditions[index].customType = 1;
  }

  filterQuery.value.conditions[index].userDept = [];
  filterQuery.value.conditions[index].departList = [];
  filterQuery.value.conditions[index].userList = [];
  filterQuery.value.conditions[index].mappingLabel = [];
  filterQuery.value.conditions[index].fieldType = allObjList.value[e]?.fieldType;
  filterQuery.value.conditions[index].fieldExt = allObjList.value[e]?.fieldType == 12 ? allObjList.value[e]?.fieldExt : null;
};

const changeChildTwo = (e, index) => {
  console.log(488, e, index, filterQuery.value.conditions[index]);
  filterQuery.value.conditions[index].value = '';
  // 动态记录特殊处理
  if (filterQuery.value.conditions[index]?.field == 'entityType' && !['null', 'not_null'].includes(e)) {
    // 不修改值
  } else {
    filterQuery.value.conditions[index].customType = ['null', 'not_null'].includes(e) ? 2 : 1;
  }
  filterQuery.value.conditions[index].mappingLabel = [];
  filterQuery.value.conditions[index].userDept = [];
  filterQuery.value.conditions[index].departList = [];
  filterQuery.value.conditions[index].userList = [];
  // if (filterQuery.value.conditions[index]?.fieldType == 8 && filterQuery.value.conditions[index].operation === 'between') {

  // }
};

//映射类型下拉选择改变时
const selectTypeChange = (v, index) => {
  console.log(175, '映射类型下拉选择', v, index);
  filterQuery.value.conditions[index].customType = v;
  filterQuery.value.conditions[index].value = null;
  filterQuery.value.conditions[index].mappingLabel = [];
};
// 获取条件下拉选择
function getConditionFilterType(field) {
  let list = [];
  const fieldType = allObjList.value[field]?.fieldType;

  if (fieldType == 21) {
    if (allObjList.value[field]?.business?.fieldType == 24) {
      const businessFieldExt = tools.isJSON(allObjList.value[field]?.business?.fieldExt) && JSON.parse(allObjList.value[field]?.business?.fieldExt);
      if ([3, 5].includes(fieldType)) {
        list = data.filterType?.[allObjList.value[field]?.business?.fieldType]?.[businessFieldExt?.type]?.filter((v) => !['equals', 'not_equals'].includes(v.value)) || [];
      } else if ([9].includes(fieldType)) {
        list = data.filterType?.[allObjList.value[field]?.business?.fieldType]?.[businessFieldExt?.type]?.filter((v) => !['between'].includes(v.value)) || [];
      } else {
        list = data.filterType?.[allObjList.value[field]?.business?.fieldType]?.[businessFieldExt?.type] || [];
      }
    } else {
      if ([3, 5].includes(fieldType)) {
        list = data.filterType?.[allObjList.value[field]?.business?.fieldType]?.filter((v) => !['equals', 'not_equals'].includes(v.value)) || [];
      } else if ([9].includes(fieldType)) {
        list = data.filterType?.[allObjList.value[field]?.business?.fieldType]?.filter((v) => !['between'].includes(v.value)) || [];
      } else {
        list = data.filterType?.[allObjList.value[field]?.business?.fieldType] || [];
      }
      console.log(523, list, data.filterType?.[allObjList.value[field]?.business?.fieldType]);
    }
  } else {
    if (allObjList.value[field]?.fieldType == 24) {
      const fieldExt = tools.isJSON(allObjList.value[field]?.fieldExt) && JSON.parse(allObjList.value[field]?.fieldExt);
      if ([3, 5].includes(fieldType)) {
        list = data.filterType?.[allObjList.value[field]?.fieldType]?.[fieldExt?.type]?.filter((v) => !['equals', 'not_equals'].includes(v.value)) || [];
      } else if ([9].includes(fieldType)) {
        list = data.filterType?.[allObjList.value[field]?.fieldType]?.[fieldExt?.type]?.filter((v) => !['between'].includes(v.value)) || [];
      } else {
        list = data.filterType?.[allObjList.value[field]?.fieldType]?.[fieldExt?.type] || [];
      }
    } else {
      if ([3, 5].includes(fieldType)) {
        list = data.filterType?.[allObjList.value[field]?.fieldType]?.filter((v) => !['equals', 'not_equals'].includes(v.value)) || [];
      } else if ([9].includes(fieldType)) {
        list = data.filterType?.[allObjList.value[field]?.fieldType]?.filter((v) => !['between'].includes(v.value)) || [];
      } else {
        list = data.filterType?.[allObjList.value[field]?.fieldType] || [];
      }
    }
  }
  return list;
}

const smStepList = computed(() => data.sourceMappingFieldList?.filter((val) => val.step < stepIndex.value) || []);

// 根据映射关系筛选可选字段
const smFieldList = (item, list, sub) => {
  if (!item?.fieldType && item?.fieldType !== 0) {
    //兼容接口请求失败时 字段不存在情况
    return [];
  }
  const fieldType = item.fieldType;
  if ([25].includes(fieldType)) {
    return list?.filter((val) => fieldType === val.fieldType && val.fieldExt == item.fieldExt);
  } else if ([12].includes(fieldType)) {
    return list?.filter((val) => ([12].includes(val.fieldType) && val.fieldExt == item.fieldExt) || [0, 13].includes(val.fieldType));
  } else if ([0].includes(fieldType)) {
    return list?.filter((val) => [0, 12].includes(val.fieldType));
  } else if ([13].includes(fieldType)) {
    return list?.filter((val) => [12, 13].includes(val.fieldType));
  } else if ([8].includes(sub.fieldType) && sub.operation === 'between') {
    return list?.filter((val) => [9].includes(val.fieldType));
  } else {
    return list?.filter((val) => fieldType === val.fieldType);
  }
};

// 类型为【字段】时，源字段的dropdown选择事件
const selectField = (group, index, v, objectTitle = null) => {
  if (objectTitle) {
    group.label = group.label.replace('记录', '对象');
  }
  // 有v代表选择的是字段，否则表示是步骤
  filterQuery.value.conditions[index].mappingLabel = v ? [`第${group.step}步 | ${v.fieldName}-【${outFieldTypeObj[v.fieldType]}】`] : [group.label];
  filterQuery.value.conditions[index].value = v ? `${group.value}:${v.fieldKey}` : group.value;

  if (group.step >= 1) {
    const list = group.step == 1 ? [] : data.triggerInfo[group.step - 2].allCycleList;
    filterQuery.value.conditions[index].allCycleList = [...new Set([...list, group.step + 1000])];
  } else {
    filterQuery.value.conditions[index].allCycleList = [];
  }
  filterQuery.value.conditions[index].isDelete = false;
};
// 人员类型
const getValUser = (v, index, type) => {
  console.log('人员信息选择', v, index, type);
  if (type === 1) {
    // 人员选择
    const userNames = v?.userList?.map((u) => u.userName);
    const userIds = v?.userList?.map((u) => u.id);
    filterQuery.value.conditions[index].userList = v?.userList;
    filterQuery.value.conditions[index].mappingLabel = userNames;
    filterQuery.value.conditions[index].value = JSON.stringify({
      userIds: userIds,
      departIds: []
    });
    console.log('人员选择', filterQuery.value.conditions[index]);
  } else {
    // 部门选择
    const deptNames = v?.departList?.map((u) => u.departmentName);
    const deptIds = v?.departList?.map((u) => u.id);
    filterQuery.value.conditions[index].departList = v?.departList;
    filterQuery.value.conditions[index].mappingLabel = deptNames;
    filterQuery.value.conditions[index].value = JSON.stringify({
      userIds: [],
      departIds: deptIds
    });
  }
};

// 日期类型获取日期变量
const getDateVariable = (record, index) => {
  console.log(274, record, index);
  filterQuery.value.conditions[index].value = record;
};

// // 删除筛选项
const deleteItem = (index) => {
  filterQuery.value.conditions.splice(index, 1);
};
console.log(deleteItem);

// 添加条件项
const addCondition = () => {
  // const _fieldInfo = null;
  filterQuery.value.conditions.push(addDefaultValue());
  nextTick(() => {
    if (findRecordsContent.value) {
      findRecordsContent.value.scrollTo({
        top: findRecordsContent.value.scrollHeight,
        behavior: 'smooth'
      });
    }
  });
};

// 级联
// const isCascader = (child) => {
//   if (!child?.setting) return false;
//   if (child.setting.fieldType === 10 || child.setting?.business?.fieldType === 10) {
//     return true;
//   } else {
//     return false;
//   }
// };

const handlePrimary = (vItem) => {
  const _copyVItem = JSON.parse(JSON.stringify(vItem));
  let resultValue;
  if ([2, 3, 4, 5, 10].includes(Number(_copyVItem.fieldType))) {
    console.log('consoleLog9');

    if (['in', 'not_in'].includes(_copyVItem.operation)) {
      if (_copyVItem.fieldType == 10) {
        // 级联
        resultValue = _copyVItem.value?.map((subArr) => subArr?.join('/'))?.join(',');
      } else {
        console.log('进入数据处理', JSON.parse(JSON.stringify(_copyVItem)));

        resultValue = _copyVItem.value?.filter((vItem) => vItem && vItem !== '')?.join(',');
      }
    } else if (_copyVItem.fieldType == 10 && ['equals', 'not_equals'].includes(_copyVItem.operation)) {
      resultValue = Array.isArray(_copyVItem.value) ? _copyVItem.value?.join('/') : _copyVItem.value;
    } else {
      resultValue = _copyVItem.value;
    }
  } else if (_copyVItem.fieldType == 16) {
    resultValue = tools.setPrice(_copyVItem.value, vItem?.targetExt || 2);
  } else if (_copyVItem.fieldType == 24 && tools.isJSON(_copyVItem?.fieldExt) && (JSON.parse(_copyVItem?.fieldExt)?.type == 6 || JSON.parse(_copyVItem?.fieldExt)?.type == 16)) {
    resultValue = tools.setPrice(_copyVItem.value, vItem?.targetExt || 2);
  } else if (_copyVItem.fieldType == 23 || (_copyVItem.fieldType == 24 && tools.isJSON(_copyVItem?.fieldExt) && JSON.parse(_copyVItem?.fieldExt)?.type == 23)) {
    resultValue = tools.setPercentage(_copyVItem.value, tools.isJSON(vItem.targetExt) && JSON.parse(vItem.targetExt)?.numberFormat);
  } else {
    console.log('consoleLog8');

    resultValue = _copyVItem.value;
  }

  return resultValue;
};

watch(
  () => filterQuery.value,
  (v) => {
    const { queryAll, conditions } = v;
    const params = conditions?.map((mItem) => {
      return {
        ...mItem,
        value: [1, 4, 6].includes(mItem.customType) ? mItem.value : mItem.customType == 2 ? handlePrimary(mItem) : null
      };
    });
    const result = {
      queryAll,
      conditions: params
    };
    console.log('抛出数据', result);
    console.log(emits);
    emits('cb', result);
  },
  { deep: true, immediate: true }
);

console.log(data, name);
</script>
<style scoped lang="less">
@import './ly-field-filter.less';
</style>
